import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useAddNode = (handleModalClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.ADD_NODE],
    (data) => ApiService.addNode(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_NODE);
        queryClient.invalidateQueries(QUERY_KEY.GET_GROUP);
        //setShowCreateGroup(false)
        toast.success('Node added successfully')
        handleModalClose()
      },
      onError: (error) => {
        error.response.data.message ? toast.error(error.response.data.message) : toast.error('internal server error')
      },
    }
  );
};

export default useAddNode